import { OperatorCompliancePage } from "@/components/non_registrant/operator-compliance-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/overview_/compliance")({
  component: OperatorCompliancePage,
});
